module.exports = __webpack_public_path__ + "static/img/icon_cloud_p6.b1766d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/cloud/images/icon_cloud_p6.jpg
// module id = LQMD
// module chunks = 21